import React from 'react'

function FaqList({ homeData }) {
  return (
    <>
    <div className="site-width">
      <div className="pagehd text-center mb-4">
        <h2>Frequently Asked Questions</h2>
      </div>
      <div className="faqsCards">
        <div className="accordion" id="accordionExampletwo">
        {homeData?.faq && homeData.faq.map((item, index) => (
          <div className={`accordion-item`} key={index}>
            <h2 className="accordion-header">
              <button
                className={`accordion-button ${index !== 0 ? 'collapsed' : '' }`} 
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapsewhy_${index}`}
                aria-expanded="true"
                aria-controls={`collapsewhy_${index}`}
              >
                {item.question} 
              </button>
            </h2>
            <div
              id={`collapsewhy_${index}`}
              className={`accordion-collapse collapse ${index === 0 ? 'show' : '' }`}
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <p>
                 {item.answer}
                </p>
              </div>
            </div>
          </div>
         ))}
          
        </div>
      </div>
    </div>
    </>
  )
}

export default FaqList
